module.exports = __webpack_public_path__ + "fonts/adellesans-regular-webfont.b6f3ed68.woff";